import { render } from "./LBInviteDenyPopup.vue?vue&type=template&id=65e826fd"
import script from "./LBInviteDenyPopup.vue?vue&type=script&lang=js"
export * from "./LBInviteDenyPopup.vue?vue&type=script&lang=js"

import "./LBInviteDenyPopup.vue?vue&type=style&index=0&id=65e826fd&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__